import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEye, faUser, faCar, faFileInvoiceDollar, faHandHoldingUsd, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";
import { useTranslation } from "react-i18next";
import PremiumUploader from "../../Components/PremiumUploader";
import { HandCoins, SquarePen } from "lucide-react";
import { NegativeNumberDisplay } from "../../utils/formatNegativeNumber";
import { useSettings } from "../../context/SettingsContext";
import Seo from "../../Components/Seo";
import { toLocal } from "../../utils/toLocal";

function CarSales() {
  const { t } = useTranslation();

  // حالات البحث والتصفية
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    customer_id: "",
    branch_id: "",
    car_id: "",
    sale_price: "",
    discount: "",
    paid: "",
    remaining: "",
    total: "",
    payment_method: "cash",
    admin_fees: "",
    license_fees: "",
    tax: "",
    bank_id: "",
    bank_order_number: "",
    bank_amount: "",
    bank_order_date: "",
    images: null,
    images_preview: null,
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [cars, setCars] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const { settings } = useSettings();

  // تحميل البيانات الأساسية (مرة واحدة فقط)
  useEffect(() => {
    loadCustomers();
    loadBranches();
    loadBanks();
  }, []);

  // 🚗 إعادة تحميل السيارات في كل مرة يتغير فيها الفرع المختار
  // لو مفيش فرع متحدد (branch_id فاضي) بيتم تحميل كل السيارات بدون فلترة
  useEffect(() => {
    loadCars(formData.branch_id);
  }, [formData.branch_id]);

  const loadCustomers = async () => {
    try {
      const response = await API.get("/get-customers");
      const allCustomers = response.data.data || [];
      setCustomers(allCustomers.filter((c) => c.can_deleted !== 0));
    } catch (err) {
      console.error("Failed to load customers", err);
    }
  };

  const loadBranches = async () => {
    try {
      const response = await API.get("/branches");
      setBranches(response.data.data || []);
    } catch (err) {
      console.error("Failed to load branches", err);
    }
  };

  // 🚗 جلب السيارات، مع إمكانية تمرير branch_id لفلترة السيارات الخاصة بفرع معين فقط
  const loadCars = async (branchId = "") => {
    try {
      const response = await API.get("/cars", {
        params: branchId ? { branch_id: branchId } : {},
      });
      setCars(response.data.data || []);
    } catch (err) {
      console.error("Failed to load cars", err);
    }
  };

  const loadBanks = async () => {
    try {
      const response = await API.get("/banks");
      setBanks(response.data.data || []);
    } catch (err) {
      console.error("Failed to load banks", err);
    }
  };

  const handleAdd = () => {
    setFormData({
      customer_id: "",
      branch_id: "",
      car_id: "",
      sale_price: "",
      discount: "",
      paid: "",
      remaining: "",
      total: "",
      payment_method: "cash",
      admin_fees: "",
      license_fees: "",
      tax: "",
      bank_id: "",
      bank_order_number: "",
      bank_amount: "",
      bank_order_date: "",
      images: null,
      images_preview: null,
      notes: "",
    });
    setSelectedCustomer(null);
    setEditId(null);
    setErrors({});
    // عند فتح مودال الإضافة من جديد، رجّع قائمة السيارات لحالتها الافتراضية (كل السيارات لحد ما يختار فرع)
    loadCars("");
    setShowModal(true);
  };

  const handleEdit = (record) => {
    const branchId = record.branch?.id || record.branch_id || "";

    setFormData({
      ...record,
      customer_id: record.customer?.id || record.customer_id || "",
      branch_id: branchId,
      car_id: record.car?.id || record.car_id || "",
      admin_fees: record.admin_fees || record.administrative_fees || "",
      paid: record.paid || record.paid_amount || "",
      remaining: record.remaining || record.remaining_amount || "",
      bank_id: record.bank_id || record.financing_entity || "",
      bank_order_number: record.bank_order_number || record.purchase_order_number || "",
      bank_amount: record.bank_amount || record.financing_amount || "",
      bank_order_date: record.bank_order_date || record.purchase_order_date || "",
      images_preview: record.images ? record.images : null,
    });
    setEditId(record.uuid);
    setErrors({});

    const customer = customers.find((c) => c.id === (record.customer?.id || record.customer_id));
    setSelectedCustomer(customer);

    // تحميل سيارات الفرع بتاع السجل اللي بنعدله (الـ useEffect المرتبط بـ branch_id هيتكفل بده تلقائيًا
    // بمجرد تحديث formData.branch_id أعلاه، فمحتاجين بس نتأكد إن السيارة الحالية (لو من فرع تاني قديم) تفضل ظاهرة)
    setShowModal(true);
  };

  const handleView = async (record) => {
    try {
      const response = await API.get(`/cars-sale/${record.uuid}`);
      setSelectedSale(response.data.data);
      setShowViewModal(true);
    } catch (err) {
      console.error("Failed to fetch sale details", err);
      toast.error(t("failed_to_load_details"));
    }
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/cars-sale/${deleteId}`);
      toast.success(t("car_sale_deleted_success"));
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error(t("delete_failed"));
    } finally {
      setDeleting(false);
    }
  };

  const handleCustomerChange = (customerId) => {
    setFormData({ ...formData, customer_id: customerId });
    const customer = customers.find((c) => c.id === customerId);
    setSelectedCustomer(customer);
  };

  // 🚗 لما يتغير الفرع: نحدّث branch_id، ونصفّر car_id لو مكنش ده وضع تعديل
  // (لأن السيارة المختارة سابقًا ممكن تكون مش موجودة في الفرع الجديد)
  const handleBranchChange = (branchId) => {
    setFormData((prev) => ({
      ...prev,
      branch_id: branchId,
      car_id: editId ? prev.car_id : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "images_preview") return;

      let value = formData[key];

      if (key === "images") {
        if (value instanceof File) data.append(key, value);
      } else if (
        value !== null &&
        value !== "" &&
        value !== undefined &&
        typeof value !== "object"
      ) {
        data.append(key, value);
      }
    });

    try {
      if (editId) {
        await API.post(`/cars-sale/${editId}?_method=PUT`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(t("car_sale_updated_success"));
      } else {
        await API.post("/cars-sale", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(t("car_sale_added_success"));
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  // الحساب التلقائي للمجموع والمتبقي
  useEffect(() => {
    const salePrice = parseFloat(formData.sale_price) || 0;
    const discount = parseFloat(formData.discount) || 0;
    const adminFees = parseFloat(formData.admin_fees) || 0;
    const licenseFees = parseFloat(formData.license_fees) || 0;
    const tax = parseFloat(formData.tax) || 0;
    const paid = parseFloat(formData.paid) || 0;

    const total = salePrice + adminFees + licenseFees + tax - discount;
    const remaining = total - paid;

    setFormData((prev) => ({
      ...prev,
      remaining: remaining.toFixed(2),
      total: total.toFixed(2),
    }));
  }, [
    formData.sale_price,
    formData.discount,
    formData.admin_fees,
    formData.license_fees,
    formData.tax,
    formData.paid,
  ]);

  const columns = [
    { header: t("customer_name"), accessor: "customer.name" },
    { header: t("branch"), accessor: "branch.name" },
    {
      header: t("car_info"),
      accessor: (row) => `${row.car?.brand || ""} ${row.car?.model || ""}`,
    },
    { header: t("sale_price"), accessor: (row) => toLocal(row.sale_price) },
    {
      header: t("discount_value"),
      accessor: (row) => <NegativeNumberDisplay value={toLocal(row.discount)} />,
    },
    { header: t("paid"), accessor: (row) => toLocal(row.paid) },
    { header: t("remaining"), accessor: (row) => toLocal(row.remaining) },
    {
      header: t("payment_method"),
      accessor: (row) => row.payment_method ? t(`payment_${row.payment_method}`) : "",
    },
    {
      header: t("actions"),
      accessor: (row) => (
        <div style={{ width: "fit-content" }} className="d-flex border mx-auto rounded">
          <Can permission="car_sale_show">
            <button className="btn btn-sm btn-info mx-1 no-style" onClick={() => handleView(row)}>
              <FontAwesomeIcon icon={faEye} style={{ fontSize: "14px" }} />
            </button>
          </Can>
          <Can permission="car_sale_show">
            <button className="btn btn-sm btn-primary mx-1 no-style" onClick={() => handleEdit(row)}>
              <SquarePen size={16} />
            </button>
          </Can>
          <Can permission="car_sale_show">
            <button className="btn btn-sm btn-danger no-style" onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} style={{ fontSize: "14px" }} />
            </button>
          </Can>
        </div>
      ),
      hideOnPrint: true,
    },
  ];

  const sectionContainerStyle = {
    padding: "15px",
    backgroundColor: "rgba(128, 128, 128, 0.04)",
    border: "1px solid rgba(128, 128, 128, 0.12)",
    borderRadius: "8px",
    marginBottom: "15px",
  };

  return (
    <>
      <Seo title={t("seo.sale_title")} description={t("seo.sale_description")} />
      <div className="container mt-5">
        <Mytitle title={t("car_sales")} />

        {/* 🔍 شريط البحث والتصفية المتطورة */}
        {/* <div className="row g-3 mb-4 p-3 rounded shadow-sm border" style={{ backgroundColor: "rgba(128, 128, 128, 0.02)" }}>
          <div className="col-md-4">
            <MyInput
              type="text"
              label={t("search_by_customer_name")}
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setRefreshKey(p => p + 1); }}
            />
          </div>
          <div className="col-md-4">
            <MyInput type="date" label={t("from")} value={startDate}
              onChange={(e) => { setStartDate(e.target.value); setRefreshKey(p => p + 1); }}
            />
          </div>
          <div className="col-md-4">
            <MyInput type="date" label={t("to")} value={endDate}
              onChange={(e) => { setEndDate(e.target.value); setRefreshKey(p => p + 1); }}
            />
          </div>
        </div> */}

        {/* مودال استمارة البيع (إضافة / تعديل) متناسق المقاسات بنسبة 100% */}
        <ModalForm
          show={showModal}
          onClose={() => setShowModal(false)}
          title={`${editId ? t("edit_car_sale") : t("add_car_sale")} ${formData?.customer?.name || ""}`}
          onSubmit={handleSubmit}
          loading={loading}
          size="lg"
          mode="form"
        >
          {/* الـ Grid الرئيسي مقسم لصف واحد يحتوي على كروت متساوية */}
          <div className="row g-3">
            {/* القسم الأول: العميل والمركبة */}
            <div className="col-md-6">
              <div style={{ ...sectionContainerStyle, height: "100%" }}>
                <MyInput
                  label={t("select_customer")}
                  value={formData.customer_id}
                  onChange={(e) => handleCustomerChange(e.target.value)}
                  error={errors.customer_id?.[0]}
                  as="select"
                  options={[
                    { value: "", label: t("select_customer") },
                    ...customers.map((c) => ({ value: c.id, label: c.name })),
                  ]}
                />

                {selectedCustomer && (
                  <div className="mb-3 p-3 rounded text-white" style={{ backgroundColor: "var(--bs-primary, #0a4179)" }}>
                    <h6 className="border-bottom pb-1 mb-2"><FontAwesomeIcon icon={faUser} className="me-1" /> {t("customer_details")}</h6>
                    <p className="mb-1 small"><strong>{t("national_id")}:</strong> {selectedCustomer.national_id}</p>
                    <p className="mb-1 small"><strong>{t("phone")}:</strong> {selectedCustomer.phone}</p>
                    <p className="mb-1 small"><strong>{t("address")}:</strong> {selectedCustomer.address}</p>
                    <p className="mb-1 small"><strong>{t("account_number")}:</strong> {selectedCustomer.account_number}</p>
                    <p className="mb-0 small"><strong>{t("bank_name")}:</strong> {selectedCustomer.bank_name}</p>
                  </div>
                )}

                <MyInput
                  label={t("select_branch")}
                  value={formData.branch_id}
                  onChange={(e) => handleBranchChange(e.target.value)}
                  error={errors.branch_id?.[0]}
                  as="select"
                  options={[
                    { value: "", label: t("select_branch") },
                    ...branches.map((b) => ({ value: b.id, label: b.name })),
                  ]}
                />

                <MyInput
                  label={t("select_car")}
                  value={formData.car_id}
                  onChange={(e) => setFormData({ ...formData, car_id: e.target.value })}
                  error={errors.car_id?.[0]}
                  as="select"
                  disabled={!formData.branch_id}
                  options={[
                    {
                      value: "",
                      label:t("select_car"),
                    },
                    ...cars
                      .filter((c) => c.status !== "sold" || c.id === formData.car_id)
                      .map((c) => ({
                        value: c.id,
                        label: `${c.brand} ${c.model} - ${c.plate_number}`,
                      })),
                  ]}
                />
              </div>
            </div>

            {/* القسم الثاني: التفاصيل المالية */}
            <div className="col-md-6">
              <div style={{ ...sectionContainerStyle, height: "100%" }}>
                <MyInput
                  label={t("sale_price")}
                  type="number"
                  value={formData.sale_price}
                  onChange={(e) => setFormData({ ...formData, sale_price: e.target.value })}
                  error={errors.sale_price?.[0]}
                />

                <MyInput
                  label={t("discount_value")}
                  type="number"
                  value={formData.discount}
                  onChange={(e) => setFormData({ ...formData, discount: e.target.value })}
                  error={errors.discount?.[0]}
                />

                <MyInput
                  label={t("total")}
                  type="number"
                  value={formData.total}
                  readOnly
                  className="bg-light"
                />

                <div className="row g-2">
                  <div className="col-md-6">
                    <MyInput
                      label={t("paid")}
                      type="number"
                      value={formData.paid}
                      onChange={(e) => setFormData({ ...formData, paid: e.target.value })}
                      error={errors.paid?.[0]}
                    />
                  </div>
                  <div className="col-md-6">
                    <MyInput
                      label={t("remaining")}
                      type="number"
                      value={formData.remaining}
                      readOnly
                      className="bg-light"
                      error={errors.remaining?.[0] || errors.remaining_amount?.[0]}
                    />
                  </div>
                </div>

                <MyInput
                  label={t("payment_method")}
                  as="select"
                  value={formData.payment_method}
                  onChange={(e) => setFormData({ ...formData, payment_method: e.target.value })}
                  options={[
                    { value: "cash", label: t("payment_cash") },
                    { value: "bank_installment", label: t("payment_bank_installment") },
                    { value: "direct_installment", label: t("payment_direct_installment") },
                    { value: "deferred", label: t("payment_deferred") },
                    { value: "network", label: t("payment_network") },
                  ]}
                  error={errors.payment_method?.[0]}
                />
              </div>
            </div>
          </div>

          {/* مربع الرسوم الإضافية (متساوي التقسيم) */}
          <div style={sectionContainerStyle} className="mt-3">
            <h6 className="mb-3 text-primary"><FontAwesomeIcon icon={faFileInvoiceDollar} className="me-2 ml-2" />{t("fees_section")}</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <MyInput
                  label={t("administrative_fees")}
                  type="number"
                  value={formData.admin_fees}
                  onChange={(e) => setFormData({ ...formData, admin_fees: e.target.value })}
                  error={errors.admin_fees?.[0]}
                />
              </div>
              <div className="col-md-4">
                <MyInput
                  label={t("license_fees")}
                  type="number"
                  value={formData.license_fees}
                  onChange={(e) => setFormData({ ...formData, license_fees: e.target.value })}
                  error={errors.license_fees?.[0]}
                />
              </div>
              <div className="col-md-4">
                <MyInput
                  label={t("tax")}
                  type="number"
                  value={formData.tax}
                  onChange={(e) => setFormData({ ...formData, tax: e.target.value })}
                  error={errors.tax?.[0]}
                />
              </div>
            </div>
          </div>

          {/* مربع بيانات الجهة التمويلية (تظهر عند اختيار الأقساط) متساوية تماماً */}
          {(formData.payment_method === "bank_installment" || formData.payment_method === "direct_installment") && (
            <div style={sectionContainerStyle} className="mt-3">
              <h6 className="mb-3 text-warning"><FontAwesomeIcon icon={faHandHoldingUsd} className="me-2 ml-2" />{t("financing_entity_info")}</h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <MyInput
                    label={t("financing_entity")}
                    value={formData.bank_id}
                    onChange={(e) => setFormData({ ...formData, bank_id: e.target.value })}
                    error={errors.bank_id?.[0]}
                    as="select"
                    options={[
                      { value: "", label: t("select_bank") },
                      ...banks.map((bank) => ({ value: bank.id, label: bank.name })),
                    ]}
                  />
                </div>
                <div className="col-md-6">
                  <MyInput
                    label={t("purchase_order_number")}
                    value={formData.bank_order_number}
                    onChange={(e) => setFormData({ ...formData, bank_order_number: e.target.value })}
                    error={errors.bank_order_number?.[0]}
                  />
                </div>
                <div className="col-md-6">
                  <MyInput
                    label={t("financing_amount")}
                    type="number"
                    value={formData.bank_amount}
                    onChange={(e) => setFormData({ ...formData, bank_amount: e.target.value })}
                    error={errors.bank_amount?.[0]}
                  />
                </div>
                <div className="col-md-6">
                  <MyInput
                    label={t("purchase_order_date")}
                    type="date"
                    value={formData.bank_order_date}
                    onChange={(e) => setFormData({ ...formData, bank_order_date: e.target.value })}
                    error={errors.bank_order_date?.[0]}
                  />
                </div>
              </div>

              {/* <MyInput
                label={t("payment_method")}
                as="select"
                value={formData.payment_method}
                onChange={(e) =>
                  setFormData({ ...formData, payment_method: e.target.value })
                }
                options={[
                  { value: "cash", label: t("payment_cash") },
                  {
                    value: "bank_installment",
                    label: t("payment_bank_installment"),
                  },
                  {
                    value: "direct_installment",
                    label: t("payment_direct_installment"),
                  },
                  { value: "network", label: t("payment_network") },
                  { value: "transfer", label: t("payment_transfer") },
                ]}
                error={errors.payment_method?.[0]}
              /> */}
            </div>
          )}

          {/* مربع المرفقات والملاحظات (متوازيين تماماً في الحجم) */}
          <div className="row g-3 mt-1">
            <div className="col-md-6">
              <div style={{ ...sectionContainerStyle, height: "100%" }}>
                <h6 className="mb-3"><FontAwesomeIcon icon={faPaperclip} className="me-2 ml-2" />{t("attachments")}</h6>
                <PremiumUploader
                  title={t("attachments")}
                  name="images"
                  preview={formData.images_preview}
                  onDelete={() => setFormData({ ...formData, images: null, images_preview: null })}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setFormData({
                        ...formData,
                        images: e.target.files[0],
                        images_preview: URL.createObjectURL(e.target.files[0]),
                      });
                    }
                  }}
                  accept="image/*"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div style={{ ...sectionContainerStyle, height: "100%" }}>
                <h6 className="mb-3">{t("notes")}</h6>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder={t("enter_notes")}
                  value={formData.notes}
                  onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                  style={{ resize: "none" }}
                />
                {errors.notes?.[0] && <div className="text-danger small mt-1">{errors.notes[0]}</div>}
              </div>
            </div>
          </div>
        </ModalForm>

        {/* 👁️ مودال عرض تفاصيل المبيعات */}
        <ModalForm
          show={showViewModal}
          onClose={() => setShowViewModal(false)}
          title={`${t("view_sale_details")} (${selectedSale?.customer?.name || ""})`}
          mode="print"
          size="lg"
        >
          {selectedSale && (
            <div className="container-fluid p-2">
              <div className="row g-3">
                <div className="col-md-6">
                  <div style={{ ...sectionContainerStyle, height: "100%" }}>
                    <h6 className="text-primary border-bottom pb-2 mb-3"><FontAwesomeIcon icon={faUser} className="me-2 ml-2"/>{t("customer_details")}</h6>
                    <p className="mb-2"><strong>{t("customer_name")}:</strong> {selectedSale.customer?.name || "-"}</p>
                    <p className="mb-2"><strong>{t("branch")}:</strong> {selectedSale.branch?.name || "-"}</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div style={{ ...sectionContainerStyle, height: "100%" }}>
                    <h6 className="text-info border-bottom pb-2 mb-3"><FontAwesomeIcon icon={faCar} className="me-2 ml-2"/>{t("car_info")}</h6>
                    <p className="mb-2"><strong>{t("car_info")}:</strong> {selectedSale.car?.brand} {selectedSale.car?.model || "-"}</p>
                    <p className="mb-2"><strong>{t("plate_number")}:</strong> <span className="badge bg-secondary">{selectedSale.car?.plate_number || "-"}</span></p>
                  </div>
                </div>
              </div>

              <div style={sectionContainerStyle} className="mt-3">
                <h6 className="text-success border-bottom pb-2 mb-3"><FontAwesomeIcon icon={faFileInvoiceDollar} className="me-2 ml-2"/>{t("financial_details")}</h6>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("sale_price")}</label>
                    <span className="fw-bold fs-6">{toLocal(selectedSale.sale_price)}</span>
                  </div>
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("discounts")}</label>
                    <NegativeNumberDisplay value={toLocal(selectedSale.discount)} />
                  </div>
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("total")}</label>
                    <span className="fw-bold fs-6 text-primary">{toLocal(selectedSale.total)}</span>
                  </div>
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("paid")}</label>
                    <span className="fw-bold text-success">{toLocal(selectedSale.paid)}</span>
                  </div>
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("remaining")}</label>
                    <span className="fw-bold text-danger">{toLocal(selectedSale.remaining)}</span>
                  </div>
                  <div className="col-md-4">
                    <label className="text-muted small d-block">{t("payment_method")}</label>
                    <span className="badge bg-light text-dark border">{t(`payment_${selectedSale.payment_method}`)}</span>
                  </div>
                </div>
              </div>

              <div style={sectionContainerStyle} className="mt-3 fees_section">
                <h6 className="text-secondary border-bottom pb-2 mb-3">{t("fees_section")}</h6>
                <div className="row text-center g-3">
                  <div className="col-md-4">
                    <span className="text-muted small d-block">{t("administrative_fees")}</span>
                    <strong>{toLocal(selectedSale.admin_fees)}</strong>
                  </div>
                  <div className="col-md-4">
                    <span className="text-muted small d-block">{t("license_fees")}</span>
                    <strong>{toLocal(selectedSale.license_fees)}</strong>
                  </div>
                  <div className="col-md-4">
                    <span className="text-muted small d-block">{t("tax")}</span>
                    <strong>{toLocal(selectedSale.tax)}</strong>
                  </div>
                </div>
              </div>

              {selectedSale.bank && (
                <div style={sectionContainerStyle} className="mt-3">
                  <h6 className="text-warning border-bottom pb-2 mb-3 d-flex align-items-center gap-1">
                    {t("financing_entity_info")} <HandCoins size={18} />
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6"><strong>{t("financing_entity")}:</strong> {selectedSale.bank?.name}</div>
                    <div className="col-md-6"><strong>{t("purchase_order_number")}:</strong> {selectedSale.bank_order_number}</div>
                    <div className="col-md-6"><strong>{t("financing_amount")}:</strong> {toLocal(selectedSale.bank_amount)}</div>
                    <div className="col-md-6"><strong>{t("purchase_order_date")}:</strong> {selectedSale.bank_order_date || "-"}</div>
                  </div>
                </div>
              )}

              <div className="row mt-3">
                <div className="col-md-12 mb-2">
                  <strong>{t("notes")}:</strong>
                  <p className="p-2 border rounded mt-1 small">{selectedSale.notes || "-"}</p>
                </div>
                {selectedSale.images && (
                  <div className="col-md-12 text-center mt-2">
                    <label className="fw-bold text-muted small d-block mb-1">{t("attachments")}</label>
                    <img src={selectedSale.images} alt="Attachment" className="img-fluid rounded border shadow-sm" style={{ maxHeight: "180px", objectFit: "contain" }} />
                  </div>
                )}
              </div>

              {/* شروط وأحكام العقد */}
              {(typeof settings?.sale_clauses === "string"
                ? JSON.parse(settings.sale_clauses)
                : settings?.sale_clauses || JSON.parse(localStorage.getItem("sale_clauses") || "[]")
              )?.length > 0 && (
                <div className="mt-3 p-3 border-top contract_clauses">
                  <h6 className="fw-bold mb-3">{t("contract_clauses")}</h6>
                  <ol className="pe-3 small">
                    {(typeof settings?.sale_clauses === "string"
                      ? JSON.parse(settings.sale_clauses)
                      : settings?.sale_clauses || JSON.parse(localStorage.getItem("sale_clauses") || "[]")
                    ).map((clause, index) => (
                      <li key={index} className="mb-2">
                        <strong>{clause.name}:</strong> {clause.desc}
                      </li>
                    ))}
                  </ol>
                </div>
              )}
            </div>
          )}
        </ModalForm>

        {/* مودال تأكيد الحذف */}
        <ModalForm
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          title={t("confirm_delete")}
          onSubmit={confirmDelete}
          loading={deleting}
          mode="confirm"
          confirmText={t("delete")}
          cancelText={t("cancel")}
        >
          {t("delete_car_sale_confirm")}
        </ModalForm>

        {/* جدول عرض البيانات */}
        <MyTable
          resource="cars-sale"
          columns={columns}
          refreshKey={refreshKey}
          title={t("car_sales")}
          queryParams={{
            search: searchTerm,
            start_date: startDate,
            end_date: endDate
          }}
          

          filters={[
            {
              name: "customer.name",
              label: t("search_by_customer_name"),
              type: "text",
            },
            
          ]}
          button={{
            text: t("add_car_sale"),
            onClick: handleAdd,
            variant: "success",
            permission: "car_sale_create",
          }}
        />
      </div>
    </>
  );
}

export default CarSales;